import { defineComponent as _defineComponent } from 'vue'
import useAvailabilityState from '@/state/availabilityState';
import NewAvailabilityPanel from '@/components/toolbar/NewAvailabilityPanel.vue';
import NewAvailabilityHeader from '@/components/toolbar/NewAvailabilityHeader.vue';
import { onMounted } from 'vue';
import AvailabilityService from '@/services/AvailabilityService';
import useAvailability from '@/mixins/useAvailability';
import { onClickOutside, templateRef } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewAvailability',
  props: {
  forceDot: Boolean
},
  setup(__props) {



const el = templateRef('el');

const { isAvailabilityPanelOpen, availability } = useAvailabilityState();
const { duration } = useAvailability(availability);

const togglePanel = () => {
  isAvailabilityPanelOpen.value = !isAvailabilityPanelOpen.value;
};

onMounted(async () => {
  availability.value = await AvailabilityService.fetchAvailability();
});

onClickOutside(el, () => {
  isAvailabilityPanelOpen.value = false;
});

return { __sfc: true,el, isAvailabilityPanelOpen, availability, duration, togglePanel, NewAvailabilityPanel, NewAvailabilityHeader }
}

})